export default {
      id: "video-event_drinking-water-usage",
      viewBox: "0 0 15 18",
      url: __webpack_public_path__ + "img/icons.svg#video-event_drinking-water",
      toString: function () {
        return this.url;
      }
    }